import { useState } from 'react';

export default function useToken() {
    const getToken = () => {
      const user = localStorage.getItem('user');
      //const userToken = JSON.parse(tokenString);
      if(user)
          return JSON.parse(user);
      return null;
    };
  
    const [token, setToken] = useState(getToken());
  
    const saveToken = user => {
      if(user != null) {
          //console.log("saveToken " + JSON.stringify(user));
          //console.log(user);
          //if(user.remember) {
        localStorage.setItem('user', JSON.stringify(user));
          //}
        setToken(user);
    } else {
        localStorage.removeItem('user');
        setToken(null);
    }};
  
    return {
      setToken: saveToken,
      token
    }
  }

/*
const saveToken = user => {
    console.log("saveToken " + user.token);
    if(user.remember) {
        localStorage.setItem('token', user.token);
    }
    setToken(user.token);
  };*/